import { useAsyncExecutor } from "async-executor-hook";
import { Toast } from "primereact/toast";
import { useEffect, useRef } from "react";
import {
  FormControl,
  FormGroup,
  useFormConfig,
  WForm,
  WFormControl,
} from "rectangular-forms";
import { BodyContainerTableCommon } from "../../../common/components/TableResponsive";
import {
  onlyLetterNumber,
  WDropdown,
  WInputText,
} from "../../../common/components/TemplateContainer/InputTemplates";
import { SaveButton } from "../../../common/components/TemplateContainer/SaveButton";
import { TemplateInputContainer } from "../../../common/components/TemplateContainer/TemplateContainer";
import { getErrorValueResponse } from "../../../common/error/Error";
import { removeNullProps } from "../../../common/utils";
import { HTTP_METHODS } from "../../../utils/constants";
import { networkBackendRequest } from "../../../utils/networkUtils";
import { REDUCE_DAYS } from "../../../utils/valueStaticConstants";
import { ContainerInputs, ContainerTitleSync } from "../SyncronizeDataStyled";

interface ICreateUserExecutorParams {
  category_option: string[];
  document_number: string;
  last_ndays: number;
  succeed?: any;
  failed?: any;
}

export const SyncronizeUsersByDocumentNumber = () => {
  const toast: any = useRef();
  const formConfig = useFormConfig({
    createForm: (data) => {
      const form = new FormGroup({
        category_option: new FormControl(),
        document_number: new FormControl(),
      });
      form.patchValue(data);
      return form;
    },
    onSubmit: (form, { processing, succeed, failed }) => {
      if (form.invalid) {
        toast.current.show({
          severity: "error",
          summary:
            "Completar todos los campos obligatorios antes de continuar. ¡Gracias!",
          contentClassName: "",
        });
        return;
      }
      const category_option = [form.value.category_option];
      processing();
      createUserExecutor.execute({
        ...form.value,
        succeed,
        failed,
        last_ndays: REDUCE_DAYS,
        category_option,
      });
    },
  });

  const createUserExecutor = useAsyncExecutor(
    (params: ICreateUserExecutorParams) => {
      const { document_number, category_option } = params;
      const urlPostDocumentNumber =
        "/sync-engine/manual-synchronization/users/by-document-number/";
      return networkBackendRequest(
        urlPostDocumentNumber,
        HTTP_METHODS.POST,
        removeNullProps({ document_number, category: category_option })
      ).then((resp) => resp.json());
    },
    {
      onSuccess: (_, params: any) => {
        params.succeed();
        formConfig.loadSucceed({ category_option: "DRIVER" });
        toast.current.show({
          severity: "success",
          summary: "Operación exitosa",
          detail: `La sincronización de ${params.document_number} se realizó con éxito.`,
          life: 5000,
        });
      },
      onError(error, params: any) {
        const errorMessage = getErrorValueResponse(error);
        params.failed();
        toast.current.show({
          severity: "error",
          summary: "Atención",
          detail: errorMessage,
          life: 3000,
        });
      },
    }
  );

  useEffect(() => {
    formConfig.loadSucceed({ category_option: "DRIVER" });
    // eslint-disable-next-line
  }, []);

  const isDisabledButton = formConfig?.form?.value.document_number < 1;

  return (
    <div>
      <Toast ref={toast}></Toast>
      <WForm formConfig={formConfig} style={{ width: "100%" }}>
        <BodyContainerTableCommon className="item-container" height="10rem">
          <div
            className="attribute"
            style={{
              display: "flex",
              alignItems: "flex-start",
              height: "100%",
            }}
          >
            <div className="titles">{"Sincronizar"}</div>
            <ContainerTitleSync>
              <div style={{ fontSize: "1.6rem", color: "#2E353D" }}>
                En base al N° documento
              </div>
              <div style={{ fontSize: "1.2rem", color: "#989CA2" }}>
                <p style={{ maxWidth: "27rem" }}>
                  Sincronice la información de los usuarios en base a su{" "}
                  <strong>categoría y número de documento.</strong>
                </p>
              </div>
            </ContainerTitleSync>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"PARÁMETROS DE SINCRONIZACIÓN"}</div>
            <div className="left-align" style={{ width: "100%" }}>
              <ContainerInputs>
                <WFormControl name="category_option">
                  <TemplateInputContainer label="Categoría" color="#002E6C">
                    <WDropdown
                      options={[
                        { label: "Conductor", value: "DRIVER" },
                        {
                          label: "Despachador Aduanero",
                          value: "CUSTOMS_DISPATCHER",
                        },
                      ]}
                      width="20rem"
                      placeholder="Tipo de Categoría"
                    />
                  </TemplateInputContainer>
                </WFormControl>
                <div>
                  <WFormControl name="document_number">
                    <TemplateInputContainer
                      label="N° Documento"
                      color="#002E6C"
                    >
                      <WInputText
                        width="100%"
                        height="4rem"
                        fontSize="1.4rem"
                        placeholder="Número de Documento"
                        onKeyPress={onlyLetterNumber}
                      />
                    </TemplateInputContainer>
                  </WFormControl>
                </div>
              </ContainerInputs>
            </div>
          </div>
          <div className="attribute" style={{ height: "100%" }}>
            <div className="titles">{"ACCIONES"}</div>
            <div className="left-align">
              <SaveButton
                label="Sincronizar"
                width="17rem"
                height="3.8rem"
                fontSize="1.5rem"
                backgroundColor="#002E6C"
                isDisabled={isDisabledButton}
              />
            </div>
          </div>
        </BodyContainerTableCommon>
      </WForm>
    </div>
  );
};
